import React from 'react';
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ListTerceirizados from '../../components/rh/terceirizados';


function TerceirizadosScreen() {
    return (
        <Fragment>
            <Head titulo="Listagem de Terceirizados da Prefeitura de Macuco" />
            <Header />
            <Container>
                <ListTerceirizados />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TerceirizadosScreen;